
/**contains both a reducer and action creators */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  transactionData: null,
  transactionStatus: 'INITIATED',
  disputeData: null,
  disputeStatus: null,
};

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    initiateTransaction: (state, action) => {
      state.transactionData = action.payload;
      state.transactionStatus = 'PAYMENT_CONFIRMED';
    },
    confirmPayment: (state) => {
      state.transactionStatus = 'PRODUCT_DELIVERY_PENDING';
    },
    productDelivery: (state) => {
      state.transactionStatus = 'COMPLETED';
    },
    initiateDispute: (state, action) => {
      state.disputeData = action.payload;
      state.disputeStatus = 'PENDING';
    },
    resolveDispute: (state) => {
      state.disputeStatus = 'RESOLVED';
    },
    completeTransaction: (state) => {
      state.transactionStatus = 'COMPLETED';
    },
    cancelTransaction: (state) => {
      state.transactionStatus = 'CANCELLED';
    },
  },
});

export const {
  initiateTransaction,
  confirmPayment,
  productDelivery,
  initiateDispute,
  resolveDispute,
  completeTransaction,
  cancelTransaction,
} = transactionSlice.actions;

export default transactionSlice.reducer;
